import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FiDollarSign, FiMove, FiArrowUpRight, FiArrowDownLeft } from 'react-icons/fi';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const AdminWallet = () => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchTransactions();
    }, []);

    const fetchTransactions = async () => {
        try {
            const token = localStorage.getItem('adminToken');
            const res = await axios.get(`${API_URL}/admin/transactions`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setTransactions(res.data.transactions);
        } catch (err) {
            console.error('Failed to fetch transactions', err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div>Loading Wallet Ledger...</div>;

    return (
        <div className="animate-fade">
            <h1 style={{ marginBottom: '2rem' }}>Wallet Ledger</h1>

            <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                    <thead>
                        <tr style={{ background: 'rgba(255,255,255,0.05)' }}>
                            <th style={{ padding: '1.25rem' }}>Time</th>
                            <th style={{ padding: '1.25rem' }}>User</th>
                            <th style={{ padding: '1.25rem' }}>Type</th>
                            <th style={{ padding: '1.25rem' }}>Amount</th>
                            <th style={{ padding: '1.25rem' }}>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {transactions.map((tx) => (
                            <tr key={tx._id} style={{ borderBottom: '1px solid var(--border)' }}>
                                <td style={{ padding: '1.25rem', fontSize: '0.875rem' }}>
                                    {new Date(tx.createdAt).toLocaleString()}
                                </td>
                                <td style={{ padding: '1.25rem' }}>
                                    <div style={{ fontWeight: 600 }}>{tx.user?.email || 'Guest'}</div>
                                    <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{tx.user?._id}</div>
                                </td>
                                <td style={{ padding: '1.25rem' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        {tx.amount > 0 ? <FiArrowUpRight color="var(--success)" /> : <FiArrowDownLeft color="var(--danger)" />}
                                        <span style={{ fontSize: '0.75rem', fontWeight: 700 }}>{tx.type.toUpperCase()}</span>
                                    </div>
                                </td>
                                <td style={{ padding: '1.25rem' }}>
                                    <div style={{ fontWeight: 800, color: tx.amount > 0 ? 'var(--success)' : 'var(--danger)' }}>
                                        {tx.amount > 0 ? '+' : ''}{Math.abs(tx.amount)} min
                                    </div>
                                </td>
                                <td style={{ padding: '1.25rem', fontSize: '0.875rem' }}>
                                    {tx.description}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminWallet;
